import React from 'react';

export const GridLines = ({ ticks, width, ...props }) => (
  <g stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.15" {...props}>
    {ticks.map(tick => (
      <line key={tick} y1={tick} y2={tick} x2={width} />
    ))}
  </g>
);
